import StickyFooter from './StickyFooter';

export default StickyFooter;
